// extracted by mini-css-extract-plugin
export default {"card":"x4qq5XLA63xacC5owWRD","disableMenuItem":"l__XCff6ibEcdaFpyvie","enableMenuItem":"ttHo1SfjbjSOZfv5zxSu"};